/**
 * Formats a numeric string to the specified precision.
 *
 * @param {string} numberString - The numeric string to be formatted.
 * @param {number} precision - The number of decimal places to retain.
 *
 * @example
 * formatNumericString('123.456', 2); // Returns '123.46'
 * formatNumericString('123.4', 2);   // Returns '123.40'
 * formatNumericString('123', 2);     // Returns '123'
 *
 * @returns {string} The formatted string with the specified number of decimal places.
 * If the input doesn't contain a decimal part or if precision is zero, the original string is returned.
 */
export const formatNumericString = (numberString = '', precision = 0) => {
  // Split string at the decimal point
  const [whole, decimal] = numberString.split('.');

  if (precision === 0)
    // If there's no decimal or nothing after the decimal, return the original string
    return whole;

  if (!decimal)
    // If there's no decimal or nothing after the decimal, return the original string
    return numberString;

  return `${parseFloat(numberString).toFixed(1)}`;
};
